module.exports = __webpack_public_path__ + "media/icon/icon-bear-green-dc5cf509.svg";